import React from 'react';
import { useAppStore } from "../../../../../GlobalStore/GlobalStore";
import { toggleUsageBasedPricing } from "../../../../../Utils/db/users/userInfo/toggleUsageBasedPricing.ts";
import { isMobileApp } from "../../../../../Utils/misc/envNameUtils";

const UsageBasedToggle: React.FC = () => {
    const userObj = useAppStore((state: any) => state.userObj);
    const setUserObj = useAppStore((state: any) => state.setUserObj);
    const environmentObj = useAppStore((state: any) => state.environmentObj);

    const handleToggle = async () => {
        await toggleUsageBasedPricing(userObj.user, setUserObj, userObj.hasUsageBasedEnabled);
    };

    return (
        <div className="flex flex-col items-center gap-0">
            {/* Recommendation Badge */}
            {!isMobileApp(environmentObj.environment) && (
                <div className="inline-flex items-center px-3 py-1 bg-gradient-to-r from-green-50 to-emerald-50 dark:bg-gradient-to-r dark:from-green-900/40 dark:to-emerald-900/40 rounded-lg border border-green-300 dark:border-green-600/50 shadow-md backdrop-blur-sm">
                    <span className="text-xs font-semibold text-green-800 dark:text-green-300">
                        💡 Highly recommended for the best experience
                    </span>
                </div>
            )}

            {/* Usage Based Toggle Container */}
            <div className="w-full flex items-center justify-between p-3 rounded-lg border border-neutral-300 dark:border-neutral-700 bg-neutral-200 dark:bg-neutral-800">
                <div className="flex flex-col">
                    <span className="text-neutral-900 dark:text-white">Usage Based Pricing</span>
                    <span className="text-xs text-neutral-600 dark:text-neutral-400">Enable this to use premium models</span>
                </div>
                <button
                    onClick={handleToggle}
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none ${
                        userObj.hasUsageBasedEnabled ? 'bg-cyan-500' : 'bg-neutral-400 dark:bg-neutral-600'
                    }`}
                    aria-label="Enable usage based pricing"
                >
                    <span
                        className={`${
                            userObj.hasUsageBasedEnabled ? 'translate-x-6' : 'translate-x-1'
                        } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
                    />
                </button>
            </div>
        </div>
    );
};

export default UsageBasedToggle;